// extracted by mini-css-extract-plugin
export default {"switch":"Switch_switch__EaiVt","switchOff":"Switch_switchOff__cNlpb","switchOn":"Switch_switchOn__qJpdU","slider":"Switch_slider__XHhi6","round":"Switch_round__s57OX"};